import React, { useState, useEffect, useContext } from 'react';
import {TextStyle, Layout, Card, Stack, Link, Button, InlineError, Icon} from '@shopify/polaris';
import {ViewMinor, ReturnMinor} from '@shopify/polaris-icons';
import {useReducerRequest} from '@thinkwell/react.common';
import {IFrameModal} from '@thinkwell/react.polaris';
import ReactHtmlParser from 'react-html-parser'
import EditContent from './EditContent';
import EditTagsForm from '../EditTagsForm';
import { ContentContext } from '../contexts/Content'
import compact from 'lodash/compact'

const formatDate = (dateStr) => {
  return new Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    month: 'long',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit'
  }).format(new Date(dateStr))
};

export default function Content(props) {
  const [content, setContent] = useContext(ContentContext);
  const [editing, setEditing] = useState(false)

  const [stateDelete, onDelete] = useReducerRequest('delete', {onSuccess: () => {
    props.onDelete && props.onDelete()
  }})
  const [stateRollback, onRollback] = useReducerRequest('put', {onSuccess: (response) => {
    const data = response.data
    setContent(data)
    props.onRollback && props.onRollback()
  }})

  const deleteContent = () => {
    onDelete(`/content/${content.id}.json`,
      null,
      'Are you sure you want to delete this content? This action is irreversible.'
    )
  }

  const rollback = async(backup) => {
    onRollback(`/content/${content.id}/rollback.json?backup_key=${encodeURIComponent(backup.key)}`)
  }

  return (
    <div className="content">
      <Layout>
        <Layout.Section primary>
          { !editing ?
          (<Card>
            <Card.Header title={content.name}>
              <Button plain onClick={() => props.navigateToRef.current(`content?type=${props.type}`, {withContext: 'url'}) }>Back to Contents</Button>
              <IFrameModal
                title={`View Content ${content.name}`}
                linkTitle="Display Content"
                url={`/content/${content.id}/view.html`}
              />
              <Button plain onClick={() => setEditing(true) }>Edit</Button>
              <Button plain destructive loading={stateDelete.requesting} onClick={deleteContent}>Delete</Button>
              {stateDelete.error ? <InlineError message={stateDelete.error} fieldID="deleteUserErrorFieldID" /> : null}
              {stateRollback.error ? <InlineError message={stateRollback.error} fieldID="rollbackErrorFieldID" /> : null}
            </Card.Header>
            <Card.Section>
              <table className="table-item"><tbody>
              { content.id ? <tr><th>ID</th><td>{content.id}</td></tr> : null }
              { content.pdf ? <tr><th>Cdn Pdf Path</th><td>{content.pdf}</td></tr> : null }
              { content.swf ? <tr><th>Cdn Swf Path</th><td>{content.swf}</td></tr> : null }
              { content.html ? <tr><th>Cdn Html Path</th><td>{content.html}</td></tr> : null }
              { content.pages ? <tr><th>Total Pages</th><td>{content.pages}</td></tr> : null }
              { content.swf_multi_page ? <tr><th>Multi Page</th><td>{content.swf_multi_page}</td></tr> : null }
              { content.subject ? <tr><th>Subject</th><td>{content.subject}</td></tr> : null }
              { content.video_id ? <tr><th>Video ID</th><td>{content.video_id}</td></tr> : null }
              { content.part_id ? <tr><th>Part ID</th><td>{content.part_id}</td></tr> : null }
              { content.duration ? <tr><th>Duration</th><td>{content.duration}</td></tr> : null }
              { content.width ? <tr><th>Width</th><td>{content.width}</td></tr> : null }
              { content.height ? <tr><th>Height</th><td>{content.height}</td></tr> : null }
              { content.transcript_html ? <tr><th>Transcript HTML</th><td>{content.transcript_html}</td></tr> : null }
              { content.transcript_pdf ? <tr><th>Transcript PDF</th><td>{content.transcript_pdf}</td></tr> : null }
              { content.transcript_swf ? <tr><th>Transcript SWF</th><td>{content.transcript_swf}</td></tr> : null }
              { content.html5 ? <tr><th>HTML5 Playback</th><td>Yes</td></tr> : null }
              { content.svg ? <tr><th>SVG Graphics</th><td>Yes</td></tr> : null }
              { content.updated_at ? <tr><th>Updated at</th><td>{formatDate(content.updated_at)}</td></tr> : null }
              </tbody></table>
            </Card.Section>
            { content.backups && content.backups.length ?
              <Card.Section title="Backups">
                <table className="table-item"><tbody>
                <tr><th>Key</th><th>Created At</th><th>View</th><th>Rollback</th></tr>
                {
                  (content.backups || []).map((backup, index) => {
                    return <tr key={`${backup.key}.${index}`}>
                      <td>{backup.key}</td>
                      <td>{formatDate(backup.created_at)}</td>
                      <td className="view-backup">
                        <IFrameModal
                          title={`View Backup`}
                          linkTitle={<Icon source={ViewMinor} />}
                          url={`/content/${content.id}/backups?backup_key=${encodeURIComponent(backup.key)}`}
                        />
                      </td>
                      <td><Button plain loading={stateRollback.requesting} icon={<Icon source={ReturnMinor} />} onClick={() => rollback(backup) }/></td>
                    </tr>
                  })
                }
                </tbody></table>
              </Card.Section> : null
            }
            <Card.Section title="Tags">
              <EditTagsForm
                onSuccess={setContent}
                item={content}
                rootName="content"
                url={`/content${`/${content.id}`}.json`}
              />
            </Card.Section>
          </Card>) : null
        }
        <EditContent
          active={editing}
          item={content}
          onSave={setContent}
          type={props.type}
          onActive={(active) => { if (active != editing) { setEditing(active) } }}
        />
        </Layout.Section>
      </Layout>
    </div>
  );
}
